<template>
    <div>
        <div class="page-btns-box" v-if="$utils.have('/message/notify/send')">
            <el-button  type="primary"  size="small" @click="$refs.add.show()" icon="el-icon-plus">新增公告</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="公告ID"></el-table-column>
                <el-table-column prop="targetTypes" label="推送对象">
                    <template slot-scope="scope">
                        {{ formatTargetTypes(scope.row.targetTypes) }}
                      </template>
                </el-table-column>
                <el-table-column prop="title" label="公告标题" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="公告内容" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalCount" label="触达人数"></el-table-column>
				<el-table-column prop="readCount" label="已读人数"></el-table-column>
                <el-table-column fixed="right" width="120" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
							icon="el-icon-edit"
                            @click="$refs.add.show(scope.row)"
                            >编辑</el-button
                        >
						<el-button
						    type="text"
						    size="small"
						    icon="el-icon-delete"
						    @click="del(scope.row.id)"
						    >删除</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <add ref="add" @onUpdate="getDataList()"></add>
        <detail ref="detail"></detail>
    </div>
</template>

<script>
import Add from './components/add.vue'
const defaultParams = {
    pageNo:1,
}
export default {
    components:{Add},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
            listLoading: false,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/announce/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
		formatTargetTypes(str) {
		    if (!str) return '-';
		    const map = { '5': '厂牌', '3': '场地', '2': '艺人' };
		    return str.split(',').map(code => map[code] || code).join('、');
		  },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		del (id) {
		    this.$confirm('删除后将不再展示此公告，确认删除？', '删除公告', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(async () => {
		        const response = await this.$request({
		            url: "/announce/delete",
		            method: "POST",
		            params: {id},
		        });
		        const {msg, state} = response.data;
		        if (state != 1) return this.$message.error(msg);
		        this.$message.success('删除公告成功');
		        this.getDataList();
		    })
		}
    }
}
</script>

<style lang="scss" scoped>

</style>